import { NUDGE_DRIVER, NUDGE_DRIVER_EMPTY, NUDGE_DRIVER_ERROR, NUDGE_DRIVER_SUCCESS } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const NudgeDriver = (state = initialState, action) => {
  switch (action.type) {
    case NUDGE_DRIVER:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case NUDGE_DRIVER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case NUDGE_DRIVER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case NUDGE_DRIVER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default NudgeDriver;
